import { render, staticRenderFns } from "./add-superior-transport-company-contractor-modal.vue?vue&type=template&id=1f1ad9e4&scoped=true"
import script from "./add-superior-transport-company-contractor-modal.vue?vue&type=script&lang=js"
export * from "./add-superior-transport-company-contractor-modal.vue?vue&type=script&lang=js"
import style0 from "./add-superior-transport-company-contractor-modal.vue?vue&type=style&index=0&id=1f1ad9e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ad9e4",
  null
  
)

export default component.exports